'use strict';

module.exports = require('./lib/React');



// WEBPACK FOOTER //
// /Users/jinxuanzhu/.nvm/versions/node/v8.4.0/lib/node_modules/react/react.js